import React from "react";
import PropTypes from "prop-types";
import RtrImage from "../../shared/rtr-image";

const ProductInfoBar = ({ productData }) => {
  if (!productData) {
    return null;
  }

  const imgUrl = "https:" + process.env.NEXT_PUBLIC_CDN_IMAGE_HOST + "/" + productData?.images?.[0];

  const removeProductionUrl = url => {
    if (url?.startsWith("http:")) {
      return url?.replace("http://www.renttherunway.com", "");
    }
    return url?.replace("https://www.renttherunway.com", "");
  };

  return (
    <div className="product-info-bar">
      {productData?.images?.[0] && (
        <div className="product-info-bar__product-image">
          <RtrImage src={imgUrl} />
        </div>
      )}
      <div className="product-info-bar__product-details">
        <span className="product-info-bar__product-details__designer">{productData?.designerDisplayName}</span>
        <span className="product-info-bar__product-details__style">{productData?.displayName}</span>
        <a className="product-info-bar__product-details__pdp-link" href={removeProductionUrl(productData?.pdpUrl)}>
          View details
        </a>
      </div>
    </div>
  );
};

ProductInfoBar.propTypes = {
  productData: PropTypes.object.isRequired,
};

export default ProductInfoBar;
